<template>
  <div>
    <header-component/>

    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="card-header">
          <h3 
            class="mb-0" 
            style="text-transform:capitalize;">Service Jobs List</h3>
          <div class="text-right">
            <el-select
              v-model="categoryId"
              filterable
              clearable
              placeholder="Service Category"
              size="small"
              class="mr-2"
              style="width: 200px;"
              @change="onCategoryChange"
            >
              <el-option
                v-for="item in serviceCategories"
                :key="item.serviceCategoryId"
                :label="item.label"
                :value="item.serviceCategoryId"
              />
            </el-select>
            <el-select
              v-model="serviceId"
              filterable
              clearable
              placeholder="Service"
              size="small"
              class="mr-2"
              style="width: 200px;"
            >
              <el-option
                v-for="item in serviceOptions"
                :key="item.serviceId"
                :label="item.label"
                :value="item.serviceId"
              />
            </el-select>
            <base-button 
              size="sm" 
              type="primary" 
              @click="createJob">Add New</base-button>
          </div>
        </div>
        <el-table
          :data="sortedJobList"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column 
            label="Name" 
            prop="label"/>
          <el-table-column label="Service Category">
            <template slot-scope="scope">
              {{ categoryLabel(scope.row.service) }}
            </template>
          </el-table-column>
          <el-table-column 
            label="Service Name" 
            prop="service">
            <template slot-scope="scope">
              {{ scope.row.service && scope.row.service.label }}
            </template>
          </el-table-column>
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown 
                slot="dropdown" 
                @command="command => handleAction(scope.row, command)">
                <el-button 
                  type="primary" 
                  size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu 
                  slot="dropdown" 
                  class="dropdown-menu dropdown-menu-arrow show">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                  <el-dropdown-item command="delete" style="color: #f56c6c">Delete</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        :visible.sync="addServiceJob" 
        :title="editMode? `Edit Service Job` : `Add Service Job`">
        <add-service-job @close="addServiceJob = false"/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddServiceJob from "./AddServiceJob";
import headerComponent from "../Components/HeaderComponent";
import Api from "@/middleware/api";
import endpoints from "@/utils/constants";
export default {
  data: () => {
    return {
      addServiceJob: false,
      editMode : false,
      categoryId: null,
      serviceId: null
    };
  },

  computed: {
    ...mapGetters({
      job: "serviceJob/getJob",
      jobList: "serviceJob/getJobList",
      serviceCategories: "serviceCategory/getServiceCategoryList",
      serviceList: "service/getServiceList"
    }),
    serviceOptions() {
      return [...(this.serviceList || [])]
        .filter(row => !this.categoryId || row.serviceCategoryId === this.categoryId)
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
    },
    sortedJobList() {
      return [...(this.jobList || [])]
        .filter(row => {
          const rowCategoryId = row.service && row.service.serviceCategoryId;
          if (this.categoryId && rowCategoryId !== this.categoryId) return false;
          if (this.serviceId && row.serviceId !== this.serviceId) return false;
          return true;
        })
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
    }
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name] : Button,
    "add-service-job": AddServiceJob,
    "header-component": headerComponent
  },
  mounted() {
    this.getServiceJobList();
    this.getServiceCategoryList();
    this.getServiceList();
  },
  methods: {
    ...mapActions({
      getServiceJobList: "serviceJob/getServiceJobList",
      fetchServiceJob: "serviceJob/fetchServiceJob",
      getServiceCategoryList: "serviceCategory/getServiceCategoryList",
      getServiceList: "service/getServiceList"
    }),
    ...mapMutations({ setJob: "serviceJob/setJob", resetJob: "serviceJob/resetJob" }),
    categoryLabel(service) {
      if (!service || !service.serviceCategoryId) return "";
      const match = (this.serviceCategories || []).find(
        item => item.serviceCategoryId === service.serviceCategoryId
      );
      return match ? match.label : "";
    },
    onCategoryChange() {
      if (!this.serviceId) return;
      const stillVisible = this.serviceOptions.some(item => item.serviceId === this.serviceId);
      if (!stillVisible) this.serviceId = null;
    },
    handleAction(job, command) {
      if (command === "edit") {
        this.fetchServiceJob(job.serviceJobId).then(async res => {
          await this.setJob(res);
          this.editMode = true;
          this.addServiceJob = true;
        });
      } else if (command === "delete") {
        if (!window.confirm("Delete this service job?")) return;
        new Api().call("delete", `${endpoints.LARAVEL_BASE_URL}/api/v1/service-jobs/${job.serviceJobId}`)
          .then(() => {
            this.getServiceJobList();
            window.notify && window.notify({ message: "Deleted", type: "success", title: "Success" });
          })
          .catch(() => {
            window.notify && window.notify({ message: "Failed to delete", type: "danger", title: "Error" });
          });
      }
    },

    createJob() {
      this.resetJob();
      this.addServiceJob = true;
      this.editMode = false;
    }
  }
};
</script>